var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", {
    staticClass: "lbs-uscope-toolbar-button",
    style: _vm.style,
    attrs: { title: _vm.title },
    on: {
      click: function($event) {
        $event.preventDefault()
        $event.stopPropagation()
        return _vm.onClick($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/components/vue/toolbar-button.vue?vue&type=template&id=5ca95fb2&scoped=true&
// module id = 383
// module chunks = 0